/**
 * Planilha Excel de conferência do eloTributos (exportação e importação), gerada no navegador com exceljs.
 *
 * Exportação: recebimentos PENDENTES com a tributação atual/sugerida de cada produto.
 *   - 1ª coluna "Conferido" (VERDADEIRO/FALSO). O operador marca as linhas revisadas.
 *   - Colunas cinza são informativas (não são importadas).
 * Importação: somente as linhas com "Conferido" marcado são enviadas; o backend valida cada linha.
 */
import ExcelJS from 'exceljs';

const TEXTO = 'texto';
const NUMERO = 'numero';
const INTEIRO = 'inteiro';
const INFO = 'info';

// tam = quantidade de dígitos do código (repõe zeros à esquerda perdidos se o Excel converter para número)
export const COLUNAS = [
  { titulo: 'Conferido', campo: 'conferido', tipo: 'bool', largura: 11 },
  { titulo: 'ID Recebimento', campo: 'idRecebimento', tipo: 'id', largura: 14 },
  { titulo: 'EAN', campo: 'codigoEan', tipo: INFO, largura: 16 },
  { titulo: 'Registro', campo: 'registroProduto', tipo: INFO, largura: 10 },
  { titulo: 'CNPJ Cliente', campo: 'cnpjEmpresa', tipo: INFO, largura: 17 },
  { titulo: 'Cliente', campo: 'nomeEmpresa', tipo: INFO, largura: 24 },
  { titulo: 'Descrição', campo: 'descricao', tipo: TEXTO, largura: 42, trib: true },
  { titulo: 'NCM', campo: 'ncm', tipo: TEXTO, tam: 8, largura: 11, trib: true },
  { titulo: 'CEST', campo: 'cest', tipo: TEXTO, tam: 7, largura: 10, trib: true },
  { titulo: 'CFOP Venda', campo: 'cfopVenda', tipo: TEXTO, largura: 11, trib: true },
  { titulo: 'Origem', campo: 'origemMercadoria', tipo: INTEIRO, largura: 8, trib: true },
  { titulo: 'CST ICMS', campo: 'cstVenda', tipo: TEXTO, tam: 2, largura: 9, trib: true },
  { titulo: 'CSOSN', campo: 'csosnVenda', tipo: TEXTO, tam: 3, largura: 8, trib: true },
  { titulo: 'Modalidade BC', campo: 'icmsModalidadeBc', tipo: INTEIRO, largura: 12, trib: true },
  { titulo: 'Alíquota ICMS', campo: 'icmsAliquota', tipo: NUMERO, largura: 12, trib: true },
  { titulo: 'Redução BC', campo: 'icmsPRedBc', tipo: NUMERO, largura: 11, trib: true },
  { titulo: 'Alíquota FCP', campo: 'icmsAliquotaFcp', tipo: NUMERO, largura: 12, trib: true },
  { titulo: 'Modalidade BC ST', campo: 'icmsModalidadeBcSt', tipo: INTEIRO, largura: 15, trib: true },
  { titulo: 'Alíquota ICMS ST', campo: 'icmsAliquotaSt', tipo: NUMERO, largura: 14, trib: true },
  { titulo: 'Redução BC ST', campo: 'icmsPRedBcSt', tipo: NUMERO, largura: 13, trib: true },
  { titulo: 'MVA', campo: 'mva', tipo: NUMERO, largura: 9, trib: true },
  { titulo: 'MVA ST', campo: 'mvaSt', tipo: NUMERO, largura: 9, trib: true },
  { titulo: 'CST PIS/COFINS Entrada', campo: 'pisCofinsEntradaCst', tipo: TEXTO, tam: 2, largura: 12, trib: true },
  { titulo: 'CST PIS/COFINS Saída', campo: 'pisCofinsSaidaCst', tipo: TEXTO, tam: 2, largura: 12, trib: true },
  { titulo: 'Natureza Receita', campo: 'naturezaReceita', tipo: TEXTO, tam: 3, largura: 10, trib: true },
  { titulo: 'cClassTrib IBS/CBS', campo: 'cClassTribIBSCBS', tipo: TEXTO, tam: 6, largura: 12, trib: true },
  { titulo: 'cClassTrib IBS/CBS Regular', campo: 'cClassTribIBSCBSRegular', tipo: TEXTO, tam: 6, largura: 14, trib: true },
  { titulo: 'cClassTrib IS', campo: 'cClassTribIS', tipo: TEXTO, tam: 6, largura: 12, trib: true },
  { titulo: 'Cód. Alíq. Créd. Presumido', campo: 'codigoAliquotasCredPresIBSCBS', tipo: TEXTO, largura: 14, trib: true },
  { titulo: 'Alíq. Ad Rem IBS', campo: 'aliquotaAdRemIBS', tipo: NUMERO, largura: 12, trib: true },
  { titulo: 'Alíq. Ad Rem CBS', campo: 'aliquotaAdRemCBS', tipo: NUMERO, largura: 12, trib: true },
  { titulo: 'Alíq. Ad Valorem IBS UF', campo: 'aliquotaAdValoremIBSUF', tipo: NUMERO, largura: 13, trib: true },
  { titulo: 'Alíq. Ad Valorem IBS Mun.', campo: 'aliquotaAdValoremIBSMun', tipo: NUMERO, largura: 13, trib: true },
  { titulo: 'Alíq. Ad Valorem CBS', campo: 'aliquotaAdValoremCBS', tipo: NUMERO, largura: 13, trib: true },
  { titulo: 'Diferimento IBS UF', campo: 'pDifIBSUF', tipo: NUMERO, largura: 12, trib: true },
  { titulo: 'Diferimento IBS Mun.', campo: 'pDifIBSMun', tipo: NUMERO, largura: 12, trib: true },
  { titulo: 'Diferimento CBS', campo: 'pDifCBS', tipo: NUMERO, largura: 12, trib: true },
  { titulo: 'NCM na NF', campo: 'ncmNota', tipo: INFO, largura: 11 },
  { titulo: 'CEST na NF', campo: 'cestNota', tipo: INFO, largura: 10 },
];

const COR_CABECALHO = 'FF0F766E';
const COR_INFO = 'FFEFF1F5';
const COR_CONFERIDO = 'FFFFF4D6';

const normalizarTitulo = t => String(t || '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/\s+/g, ' ').trim().toUpperCase();

/** Valor "cru" de uma célula do exceljs (trata fórmula, rich text, hyperlink e datas). */
function valorCelula(cell) {
  const v = cell ? cell.value : null;
  if (v === null || v === undefined) return null;
  if (typeof v === 'object' && !(v instanceof Date)) {
    if (Object.prototype.hasOwnProperty.call(v, 'result')) return v.result;
    if (Array.isArray(v.richText)) return v.richText.map(r => r.text).join('');
    if (Object.prototype.hasOwnProperty.call(v, 'text')) return v.text;
    return null;
  }
  return v;
}

export function lerBooleano(v) {
  if (v === true) return true;
  if (v === false || v === null || v === undefined) return false;
  if (typeof v === 'number') return v === 1;
  const s = normalizarTitulo(v);
  return ['S', 'SIM', 'X', '1', 'TRUE', 'VERDADEIRO', 'V', 'OK'].includes(s);
}

function lerTexto(v, tam) {
  if (v === null || v === undefined) return '';
  let s;
  if (typeof v === 'number') {
    s = String(Math.trunc(v));
    if (tam && s.length < tam) s = s.padStart(tam, '0');
  } else {
    s = String(v).trim();
  }
  return s;
}

function lerNumero(v) {
  if (v === null || v === undefined || v === '') return 0;
  if (typeof v === 'number') return v;
  const s = String(v).trim().replace('%', '').replace(/\s/g, '');
  // "1.234,56" -> 1234.56 ; "18,5" -> 18.5 ; "18.5" -> 18.5
  const normal = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
  const n = Number(normal);
  return Number.isFinite(n) ? n : NaN;
}

// Planilha da Base de tributos: chave = ID do produto; inclui situação e data da conferência (informativas)
export const COLUNAS_PRODUTO = [
  COLUNAS[0],
  { titulo: 'ID Produto', campo: 'idProduto', tipo: 'id', largura: 11 },
  ...COLUNAS.filter(c => ['codigoEan', 'registroProduto', 'cnpjEmpresa'].includes(c.campo)),
  { titulo: 'Situação', campo: 'situacao', tipo: INFO, largura: 20 },
  { titulo: 'Conferido em', campo: 'dataConferencia', tipo: INFO, largura: 13 },
  ...COLUNAS.filter(c => c.trib),
];

const colunasDoModo = modo => (modo === 'produto' ? COLUNAS_PRODUTO : COLUNAS);

/** Converte os produtos da Base de tributos (GET /tributosproduto) para as linhas da planilha. */
export function linhasDeProdutos(produtos) {
  return (produtos || []).map(p => {
    let situacao = 'Não conferido';
    if (p.atualizado) situacao = 'Conferido';
    else if (p.conferido) situacao = 'Conferência vencida';
    return {
      idProduto: p.id,
      codigoEan: p.codigoEan,
      registroProduto: p.registroProduto,
      cnpjEmpresa: p.cnpjCliente,
      situacao,
      dataConferencia: p.dataConferencia ? String(p.dataConferencia).replace(/-/g, '/') : '',
      descricao: p.descricao,
      tributos: p,
    };
  });
}

/**
 * Gera o arquivo .xlsx (ArrayBuffer).
 * modo 'recebimento': linhas de /recebimento/exportar; modo 'produto': linhas de linhasDeProdutos().
 */
export async function gerarPlanilha(linhas, modo = 'recebimento') {
  const COLUNAS = colunasDoModo(modo); // eslint-disable-line no-shadow
  const wb = new ExcelJS.Workbook();
  wb.creator = 'eloTributos';
  wb.created = new Date();
  const ws = wb.addWorksheet('Conferência', { views: [{ state: 'frozen', xSplit: 2, ySplit: 1 }] });

  ws.columns = COLUNAS.map(c => ({
    header: c.titulo,
    key: c.campo,
    width: c.largura,
    style: c.tipo === TEXTO || c.tipo === INFO ? { numFmt: '@' } : (c.tipo === NUMERO ? { numFmt: '0.00##' } : {}),
  }));

  (linhas || []).forEach(l => {
    const t = l.tributos || {};
    const row = {};
    COLUNAS.forEach(c => {
      if (c.campo === 'conferido') row[c.campo] = false;
      else if (c.trib) {
        const v = c.campo === 'descricao' ? (t.descricao || l.descricao) : t[c.campo];
        if (c.tipo === NUMERO) row[c.campo] = v === null || v === undefined || v === '' ? 0 : Number(v);
        else if (c.tipo === INTEIRO) row[c.campo] = v === null || v === undefined || v === '' ? null : Number(v);
        else row[c.campo] = v === null || v === undefined ? '' : String(v).trim();
      } else {
        const v = l[c.campo];
        row[c.campo] = c.tipo === 'id' ? v : (v === null || v === undefined ? '' : String(v).trim());
      }
    });
    ws.addRow(row);
  });

  // Cabeçalho
  const cab = ws.getRow(1);
  cab.height = 32;
  cab.eachCell(cell => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: COR_CABECALHO } };
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  });

  // Destaques: coluna Conferido e colunas informativas
  const total = ws.rowCount;
  COLUNAS.forEach((c, i) => {
    if (c.tipo !== 'bool' && c.tipo !== INFO && c.tipo !== 'id') return;
    const col = ws.getColumn(i + 1);
    col.eachCell({ includeEmpty: false }, (cell, numLinha) => {
      if (numLinha === 1) return;
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: c.tipo === 'bool' ? COR_CONFERIDO : COR_INFO } };
      if (c.tipo === 'bool') cell.alignment = { horizontal: 'center' };
    });
  });

  ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: Math.max(total, 1), column: COLUNAS.length } };

  // Aba de instruções
  const ajuda = wb.addWorksheet('Instruções');
  ajuda.getColumn(1).width = 110;
  [
    'Planilha de conferência eloTributos',
    '',
    '1. Revise a tributação de cada produto nas colunas brancas.',
    '2. Na coluna "Conferido", marque VERDADEIRO (ou S / SIM / X / 1) nas linhas que estiverem corretas.',
    modo === 'produto'
      ? '3. No painel, em Base de tributos, use "Importar planilha" e selecione este arquivo.'
      : '3. No painel, em Recebimentos, use "Importar planilha" e selecione este arquivo.',
    '',
    'Somente as linhas com "Conferido" marcado são importadas. Cada linha é validada (NCM, CST/CSOSN, CFOP, CEST com ST etc.);',
    'as linhas inválidas não são gravadas e aparecem no resultado da importação com o número da linha e o motivo.',
    modo === 'produto'
      ? 'As colunas cinza (ID, EAN, Registro, CNPJ, Situação, Conferido em) são apenas informativas. Não altere a coluna "ID Produto".'
      : 'As colunas cinza (ID, EAN, Registro, Cliente, NCM/CEST na NF) são apenas informativas. Não altere a coluna "ID Recebimento".',
    'Os códigos (NCM, CEST, CST, CSOSN, cClassTrib...) estão formatados como texto para manter os zeros à esquerda.',
  ].forEach((t, i) => {
    const cell = ajuda.getCell(i + 1, 1);
    cell.value = t;
    if (i === 0) cell.font = { bold: true, size: 14 };
  });

  return wb.xlsx.writeBuffer();
}

/**
 * Lê a planilha (ArrayBuffer) e retorna { modo, total, marcadas, itens, avisos }.
 * modo: 'recebimento' (coluna "ID Recebimento") ou 'produto' (coluna "ID Produto").
 * itens: [{ linha, idRecebimento | idProduto, tributos }] somente das linhas com "Conferido" marcado.
 */
export async function lerPlanilha(buffer) {
  const wb = new ExcelJS.Workbook();
  await wb.xlsx.load(buffer);
  const ws = wb.worksheets.find(w => {
    const titulos = [];
    w.getRow(1).eachCell(c => titulos.push(normalizarTitulo(valorCelula(c))));
    return titulos.includes('CONFERIDO') && (titulos.includes('ID RECEBIMENTO') || titulos.includes('ID PRODUTO'));
  });
  if (!ws) {
    throw new Error('Planilha inválida: não encontrei as colunas "Conferido" e "ID Recebimento"/"ID Produto". Use a planilha exportada pelo painel.');
  }

  const indice = {};
  ws.getRow(1).eachCell((cell, col) => { indice[normalizarTitulo(valorCelula(cell))] = col; });
  const colunaDe = c => indice[normalizarTitulo(c.titulo)];
  const modo = indice['ID RECEBIMENTO'] ? 'recebimento' : 'produto';
  const COLUNAS = colunasDoModo(modo); // eslint-disable-line no-shadow
  const campoId = modo === 'produto' ? 'idProduto' : 'idRecebimento';

  const itens = [];
  const avisos = [];
  let total = 0;

  ws.eachRow((row, numLinha) => {
    if (numLinha === 1) return;
    const id = valorCelula(row.getCell(colunaDe(COLUNAS[1])));
    const conferido = valorCelula(row.getCell(colunaDe(COLUNAS[0])));
    if ((id === null || id === '') && (conferido === null || conferido === '')) return; // linha vazia
    total += 1;
    if (!lerBooleano(conferido)) return;

    const tributos = {};
    COLUNAS.filter(c => c.trib).forEach(c => {
      const col = colunaDe(c);
      if (!col) return; // coluna removida da planilha: não envia (mantém o valor atual)
      const v = valorCelula(row.getCell(col));
      if (c.tipo === NUMERO) {
        const n = lerNumero(v);
        if (Number.isNaN(n)) avisos.push(`Linha ${numLinha}: valor inválido em "${c.titulo}" (${v}); considerado 0.`);
        tributos[c.campo] = Number.isNaN(n) ? 0 : n;
      } else if (c.tipo === INTEIRO) {
        // Vazio = null (o backend aplica o padrão, ex.: modalidade da BC = 3)
        const n = v === null || v === undefined || String(v).trim() === '' ? null : lerNumero(v);
        tributos[c.campo] = n === null || Number.isNaN(n) ? null : Math.trunc(n);
      } else {
        tributos[c.campo] = lerTexto(v, c.tam);
      }
    });

    const idNumero = Number(lerTexto(id));
    itens.push({ linha: numLinha, [campoId]: Number.isFinite(idNumero) && idNumero > 0 ? idNumero : null, tributos });
  });

  return {
    modo, total, marcadas: itens.length, itens, avisos,
  };
}
